import type { AgendaItem, AgendaItemType } from '../event/types';

export type TranstitionItem = Omit<AgendaItem, 'type'> & {
  type: AgendaItemType | 'BREAK_OUT';
};

export type Transition = {
  item: AgendaItem | TranstitionItem;
  expiresAt?: Date;
};

export type ProgressBarConfig = {
  totalVideoDuration: number;
  currentVideoDuration: number;
  showProgressBar: boolean;
};

export type EventStageState = {
  heartBeatDate?: Date;
  heartBeatInterval?: any;
  fullScreen: Boolean;
  transitions: Record<string, Transition>;
  hasUserEnabledCaptions: Boolean;
  captionLanguage: String;
  transition?: {
    active: boolean;
    item?: AgendaItem | any;
    time?: Date;
  };
  showEngagementPanel: boolean;
  showChatOnMobile?: boolean;
  showChatOnTV?: boolean;
  forceShowViewAsAttendeeTooltip: boolean;
  attendeeTooltipMessage: string;
  isTVMode: boolean;
  isLiveStreamMode: boolean;
  progressBarConfig: ProgressBarConfig;
  isHLSVideoPlayerHovered: boolean;
  isSimuliveTestBufferMessageShown: boolean;
  muted: boolean;
  userProfileDropdownOpen: boolean;
  tvWindow?: Window;
  transitionToMainStage: boolean;
  greenRoomVideoMuted: boolean;
  volume: {
    stage: {
      level: string;
      mutedAt: string;
    };
    backstage: {
      level: string;
      mutedAt: string;
    };
  };
  connectToBackstage: boolean;
  backStageVisibility: boolean;
  speakerNotesVisibility: boolean;
  usePPTAnimations: boolean;
  runOfShowSetup: {
    isRunning: boolean;
    isPlaying: boolean;
    seekPosition: number;
    duration: number;
  };
};

export type Language = {
  language: string;
  code: string;
  ariaLabel: string;
};

export type ProfileDropdownLink = {
  label: string;
  type?: 'toggle' | 'button' | 'tick' | 'icon-action' | 'skeleton';
  icon?: string;
  action?: Function;
  size?: string;
  tooltip?: string;
  bg?: boolean;
  testmarker?: string;
  value?: string;
  selected?: boolean;
  tooltipInfo?: string;
  buttonText?: string;
  links?: ProfileDropdownLink[];
  ariaLabel?: string;
};

export enum DemoRequestSubmitType {
  ONE_CLICK = 'ONE_CLICK',
  TWO_STEP = 'TWO_STEP'
}
